/** Turn FastAPI `detail` (string, validation array, or object) into user-facing text. */
export function formatApiErrorDetail(detail: unknown, fallback: string): string {
    if (detail == null || detail === '') {
        return fallback;
    }
    if (typeof detail === 'string') {
        return detail;
    }
    if (Array.isArray(detail)) {
        const messages = detail
            .map((item) => {
                if (typeof item === 'string') {
                    return item;
                }
                if (item && typeof item === 'object' && 'msg' in item) {
                    return String((item as { msg: unknown }).msg);
                }
                return null;
            })
            .filter((msg): msg is string => Boolean(msg));
        return messages.length > 0 ? messages.join(' ') : fallback;
    }
    if (typeof detail === 'object' && detail !== null && 'msg' in detail) {
        return String((detail as { msg: unknown }).msg);
    }
    return fallback;
}
